var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.boxClass},_vm.$listeners),[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }